/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components.data').factory('ClipResourceFactory', function ($resource, EndPointService) {
	return $resource(EndPointService.clipEndpoint + '/:id', {action: '@action'},
		{
			'acceptClip': {
				method: 'PUT',
				url: EndPointService.clipEndpoint + '/:id',
				params: {id: '@id', action: 'accept'},
				isArray: false
			},
			'acceptAndDeliverClip': {
				method: 'PUT',
				url: EndPointService.clipEndpoint + '/:id',
				params: {id: '@id', action: 'accept_and_deliver'},
				isArray: false
			},
			'resetClip': {
				method: 'PUT',
				url: EndPointService.clipEndpoint + '/:id',
				params: {id: '@id', action: 'reset'},
				isArray: false
			},
			'uploadThumbnail': {
				method: 'POST',
				url: EndPointService.clipEndpoint + '/:id/images',
				params: {id: '@id'},
				isArray: false
			},
			'createDraftClip': {
				method: 'POST',
				url: EndPointService.clipEndpoint + '/:id/draftClips',
				params: {
							id: '@id',
						 	numberOfClips: '@numberOfClips',
						 	title: '@title',
							scheduleId: '@scheduleId'
						},
				isArray: true
			}
		});
});
